import Head from 'next/head'

import Layout from '@/components/Layout'

export default function ReturnPolicy(): JSX.Element {
	return (
		<div className="sm:py-8">
			<Head>
				<title key="page-title">Return and Shipping Policy | Pace International</title>
			</Head>

			<style jsx>{`
				h2 {
					@apply text-2xl mt-8 uppercase;
				}

				h3 {
					@apply text-xl mt-8;
				}

				h4 {
					@apply font-bold uppercase mt-8;
				}

				h2 + h3, h3 + h4 {
					@apply mt-4;
				}

				ul, ol {
					@apply pl-8;
				}

				ul {
					@apply list-disc;
				}

				ol {
					@apply list-decimal;
				}

				p, li {
					@apply mt-2;
				}

				li > p {
					@apply mt-0;
				}

				li > p:first-child, li > span:first-child {
					@apply font-bold;
				}

				a {
					@apply text-green-400 font-extrabold break-words;
				}

				a:hover {
					@apply underline;
				}
			`}</style>
			<div className="container mx-auto px-4 py-4 rounded-xl text-gray-800 sm:px-8">
				<h1 className="text-4xl font-black uppercase">Returns &amp; Shipping</h1>

				<h2>Same Day Shipping</h2>
				<p>Orders received before 2:00 PM CT will be shipped same day.</p>

				<h2>Terms</h2>
				<p>Cash, MasterCard, Visa, Discover, American Express, Bank Wire, Company Check upon approval and Net 30 days for qualified buyers. Prices do not include freight charges or insurance.</p>

				<h2>Business Hours</h2>
				<p>Monday through Friday 8:00 AM to 5:00 PM CT.</p>

				<h2>Catalog and Price List Errors</h2>
				<p>The accuracy of the catalog and prices listed have been carefully checked before publishing and we believe them to be reliable. However, Pace International assumes no responsibility for any inaccuracies or typographical errors that may exist. All information in the Shop area of the website is subject to change without notice. Pace is not responsible for manufacturer's changes in specifications or pricing.</p>
				<p>Prices and availability are subject to change without notice.</p>

				<h2>DOA Policy</h2>
				<p>Pace stands behind everything we sell. For 30 days from the date purchased from Pace, we will replace the product if deemed Dead on Arrival (DOA). After 30 days Pace will instruct you on how to get your product replaced or repaired under warranty from the manufacturer.</p>

				<h2>Damaged Merchandise</h2>
				<p>Please inspect your shipment for shortages and any damage. By signing for the shipment you are accepting the responsibility for the damaged goods and no freight claim can be collected. If anything on the shipment appears damaged and you choose to receive the order, put notes on the Bill of Lading. Pace's obligation ends when the freight carrier picks up the shipment.</p>

				<h2>Return Policy</h2>
				<p>Pace will accept product returns if:</p>
				<ul>
					<li>The item was not a special order.</li>
					<li>Item is returned in like–new condition with all accessories in original box.</li>
					<li>Proper Return Authorization procedures are followed - please visit the My Returns section of your profile to submit a return.</li>
				</ul>
				<p>No returns will be accepted without return authorization. Contact the Customer Service department at <a href="tel:18004447223">800-444-7223</a> for any questions when submitting Returns. A 15% restocking fee may be assessed.</p>
			</div>
		</div>
	)
}

ReturnPolicy.Layout = Layout
